// Dutch

export default {
  component: {

    supportLink: 'support@recright.com',

    layout: {
      endTime: date => (date ? `open tot ${date}` : ''),
    },
    interview: {
      title: 'Video-interview beantwoorden',
      submit: 'Stuur antwoorden in en beindig interview',
      continueLater: 'Later verdergaan',
      startInterview: 'Het gesprek starten',
      duplicateError: 'U heeft al deelgenomen aan dit interview. U heeft een e-mail ontvangen van invitations@recright.com met een link die u kunt gebruiken om verder te gaan met het interview',
      confirmSubmitHeader: 'U heeft niet alle interview-vragen beantwoord',
      confirmSubmitContent: 'Wilt u echt het interview beindigen?',
      confirmSubmitContentWarning: 'Daarna kunt u niet verdergaan met uw antwoorden.',
      submitInterviewHeader: 'Dien uw antwoorden op het interview in',
      submitInterviewContent: 'Weet u zeker dat u uw interview wilt indienen?',
      confirmSubmitButton: 'Verzend antwoorden en voltooi gesprek',
      preview: 'Hier kun je voorbeelden van de videovragen bekijken.',
      withdrawLink: 'Niet meer in deze functie geïnteresseerd? Trek je hier uit het proces terug.',
    },

    personalInterview: {
      title: 'Select time for an appointment',
      description: [
        'You have been invited to an appointment.',
        'Please select a time slot that suits you best.',
      ],
      position: 'Position:',
      location: 'Location:',
      time: 'Time:',
      timezoneNotice: [
        'Please keep in mind that the times are shown in your timezone.',
        'Your timezone appears to be:',
        'The appointment timezone is:',
      ],
      success: {
        title: 'Thank you',
        description: 'You have successfully scheduled a meeting',
        linkDescription: [
          'You can add the calendar invitation to your own calendar below.',
          'Or you can copy the link to your calendar app:',
        ],
        link: 'Add the calendar invitation to your calendar',
      },
    },

    interviewForm: {
      name: 'Naam',
      city: 'woonplaats',
      email: 'E-mail',
      phone: 'Telefoonnummer',
      link: 'Koppeling',
      legendBasicInfo: 'Basisinformatie',
      placeholderName: 'Voer uw naam in',
      placeholderEmail: 'Voer uw e-mailadres in',
      placeholderPhone: 'Voer uw telefoonnummer in',
      placeholderCity: 'Voer in in welke stad/welk dorp je momenteel woont',
      placeholderLink: 'Voeg link toe, bijvoorbeeld van uw LinkedIn profiel.',
      legendAttachments: 'Bijlagen',
      legendAdditionalFields: 'Aanvullende informatie',
      required: 'Items gemarkeerd met een * asterisk zijn verplicht.',
    },

    sequencedInterview: {
      networkTest: {
        audio: 'Audio',
        video: 'Video',
        yes: 'Ja',
        no: 'Nee',
        supported: 'Ondersteund',
        quality: 'Kwaliteit',
        header: 'Netwerkverbinding en apparaattest',
        description: 'We voeren een test uit om te controleren of je netwerkverbinding en de nodige hardware (camera en telefoon) correct werken. Geef a.u.b. toestemming voor de camera- en microfoontest en zorg ervoor dat de camera niet is afgedekt. De test duurt ongeveer 30 seconden. We raden je aan tijdens de hardwaretest iets te zeggen.',
        inProgress: 'Testen…',
        networkTestResults: 'Resultaten netwerktest',
        qualityTestResults: 'Resultaten kwaliteitstest',
        testPassedQuality: 'Kwaliteitstest geslaagd',
        testFailedQuality: 'Kwaliteitstest mislukt',
        testFailedNetwork: 'Netwerktest mislukt',
        testPassedNetwork: 'Netwerktest geslaagd',
        startTest: 'De test starten',
        startInterview: 'Het gesprek starten',
        testAgain: 'Opnieuw testen',
        confirmWarning: 'Wanneer uw videosollicitatiegesprek van start gaat, gaat u automatisch naar uw eerste gespreksvraag. Na het bekijken van de vraag, gaat u automatisch naar de voorbereiding.',
        confirmTitle: 'Je staat op het punt je gesprek te starten',
        confirmText: 'U hebt voor elke vraag een korte periode om uw antwoord voor te bereiden. Na de voorbereiding hebt u een vastgestelde hoeveelheid tijd om de vraag te beantwoorden. Let op dat u uw antwoord ook kunt geven wanneer u daar klaar voor bent; u hoeft niet te wachten totdat de tijd om is.',
        confirmText2: 'Na het verzenden van je antwoord word je doorgestuurd naar de volgende vraag totdat alle vragen zijn beantwoord.',
        confirmText3:
          'Na het opnemen van uw antwoord op de vraag heeft u 30 seconden de tijd om uw antwoord opnieuw op te nemen, als dit is toegestaan voor de vraag. Als u binnen 30 seconden geen nieuwe opname start, wordt uw huidige antwoord automatisch ingediend en gaat u verder naar de volgende vraag.',
        goodLuck: 'Haal diep adem; het komt allemaal goed. Veel succes!',
        qualityRating: {
          excellent: 'Fantastisch',
          good: 'Goed',
          fair: 'Gemiddeld',
          poor: 'Zwak',
          bad: 'Slecht',
        },
      },
      questionAnswerView: {
        title: title => `Antwoord voor gesprek ${title}`,
        question: 'Vraag',
        submitAndNext: 'Verzenden & Volgende',
        submitSuccess: 'Video is verzonden!',
        skipText: 'Opname starten',
        stop: 'Stoppen',
        submitAndFinish: 'Verzenden & het sollicitatiegesprek afronden',
        retake: 'Opnieuw',
        take: 'Poging',
        takesLeft: 'Resterend aantal pogingen',
        skipTextQuestion: 'Klaar? Verdergaan',
        retakeConfirmTitle: 'Weet u zeker dat u uw antwoord voor deze vraag opnieuw wilt opnemen?',
        retakeConfirmSubmit: 'Ja, nieuwe opname starten',
        submitInfoForward: 'Uw antwoord wordt automatisch ingediend en u gaat verder naar de volgende vraag over',
        submitInfoForward2: 'seconden',
        nonAnswerableText: 'Dit bericht vereist geen antwoord. Na dit bericht wordt u meteen doorverwezen naar de volgende vraag.',
        nonAnswerableVideo: 'Deze video vereist geen antwoord. Na deze video wordt u meteen doorverwezen naar de volgende vraag.',
        answerTimeInfo: (answerMinutes, answerSeconds) =>
          `Je hebt ${answerMinutes} minuten en ${answerSeconds} seconden om de vraag te beantwoorden.`,
      },
      publisher: {
        toNextQuestion: timer => `Doorgaan naar volgende vraag: ${timer}`,
        recordingStarts: timer => `De opname start over ${timer}`,
      },
      errors: {
        tooManyConnections: 'Deze verbinding werd afgesloten omdat u al een verbinding open heeft staan in een ander tabblad of venster.',
        unsupportedBrowser: 'Helaas ondersteunt je browser deze handeling niet. Gebruik een andere browser a.u.b.',
        networkError: 'Geen internetverbinding.',
        reconnecting: 'De verbinding is verbroken. Er wordt opnieuw verbinding gemaakt.',
        generalError: 'Er ging iets verkeerd. Ververs de pagina en probeer het opnieuw.',
        allowMediaDevicesError: 'Deze handeling kon geen mediabestanden ophalen (camera of microfoon). Zorg ervoor dat je de browser toestemming hebt gegeven om de camera en de microfoon te gebruiken.',
        noAvailableDevicesError: 'We kunnen geen camera of microfoon vinden.',
        initPublisherError: 'De bewerking is mislukt door een fout. Zorg ervoor dat de browser toestemming heeft om uw camera en microfoon te gebruiken, controleer dat ze niet door een andere toepassing worden gebruikt en probeer het opnieuw.',
      },
      browserInfo: {
        browserSupportTitle: 'Browserondersteuning',
        supportedBrowsers: 'Deze test en het gesprek ondersteunen de meest recente versie van Chrome, Firefox, Safari en Edge.',
        mobileSupported: 'Ondersteunde mobiele browsers',
        android: 'Android: Google Chrome (meest recente versie), Firefox (meest recente versie)',
        iOS: 'iOS: Safari (meest recente versie)',
        latestVersion: 'Zorg ervoor dat je de meest recente versie van de browser gebruikt. Op die manier garandeer je dat alles vlekkeloos werkt.',
        freezeInstruction: 'Vernieuw de pagina als de video-opname niet start of het opnamescherm zwart blijft.',
        unsupportedOnIos: 'Zo te zien gebruik je een iOS-browser die niet wordt ondersteund. Gebruik Safari, a.u.b.',
        ieUnsupported: 'Zo te zien gebruik je Internet Explorer. Helaas wordt Internet Explorer niet ondersteund voor deze test of dit gesprek. Gebruik een andere browser a.u.b.',
        qualityTestNotSupported: 'Helaas wordt het testen van hardware niet ondersteund door de browser die je gebruikt. Je kunt doorgaan met het gesprek zonder de kwaliteit van de audio en video te testen, of gebruik een andere browser.',
      },
      reconnectSuccess: 'Opnieuw verbonden!',
      continue: 'Doorgaan',
    },

    withdraw: {
      title: 'Niet meer in deze functie geïnteresseerd?',
      description: 'Trek je terug uit het proces',
      buttonText: 'Terugtrekken uit het sollicitatieproces',
      thankYouTitle: 'Bedankt!',
      thankYouText: 'Je hebt de recruiters geïnformeerd dat je niet langer in de functie geïnteresseerd bent.',
      confirm: 'Weet je zeker dat je je wilt terugtrekken uit het sollicitatieproces? Na terugtrekking ben je niet meer in staat om op dit of andere interviews die verband houden met deze functie,  te antwoorden.',
    },
  },

  page: {
    embeddedProfileInterview: {
      submit: 'Verzenden',
      continue: 'Doorgaan',
      supportCenter: 'Recright Help Center',
      thankYou:
        'Bedankt voor je video-antwoorden! Wij nemen snel contact met u op!',
    },

    supportLink: 'support@recright.com',

    finished: {
      title: 'Dank u voor uw deelname aan het interview!',
      reopenDescription: 'Geen zorgen als je dit gesprek per ongeluk hebt afgesloten. Je kunt het gesprek heropenen door op de onderstaande knop te klikken.',
      reopenButtonText: 'Gesprek heropenen',
      description1: 'Geweldig, u heeft alle vragen beantwoord en deze zijn nu naar de ontvanger gestuurd.',
      descriptionsupport: mailto => `Als u per ongeluk dit interview heeft afgesloten, gelieve dan contact op te nemen met onze klantenservice ${mailto} waarna wij uw interview opnieuw zullen openen`,
      descriptionfeedback: 'Uw ervaring is belangrijk voor ons! Hoe heeft u het ervaren om antwoorden te geven via een video-interview? Hoe zou u onze dienst verbeteren? Laat hier uw mening achter',
      feedbackbutton: 'Geef ons uw mening!',
      regularUrl: 'https://www.surveymonkey.com/r/B3ZCSWT',
      timedUrl: 'https://www.surveymonkey.com/r/MZMLPPT',
    },
    messages: {
      title: 'Persoonlijke boodschap',
    },

    closed: {
      title: 'Interview is nu afgerond of beindigd',
      description: 'Het video-interview waar u voor uitgenodigd bent is al beindigd of u heeft uw inzending afgerond.',
      publicTitle: 'Interview has ended',
      publicDescription: 'The video interview has already ended.',
    },
    saved: {
      title: 'Uw video-interview is nu opgeslagen!',
      description: 'Als u het video-interview wilt voortzetten, gebruik dan de link die u eerder via e-mail heeft ontvangen. De reeds opgenomen video-antwoorden zullen beschikbaar zijn als u terugkomt! Veel succes bij het zoeken naar werk!',
      remember: 'Vergeet niet om de antwoorden te sturen naar de recruiter nadat u klaar bent met het beantwoorden van het interview.',

      deleteHistory: 'Als u de video-interview uitvoert op een openbare computer, vergeet dan niet om uw browsergeschiedenis te wissen. Zo blijft uw interview veilig.',
    },
    unpublished: {
      title: 'Het interview is nog niet geopend',
      publishTime: publishTime => `Het interview opent om ${publishTime}`,
    },
  },
}
